$(document).ready(function(){
  
  if($('[data-type="bundle-pack"]').length != 0)
  {
    $(".custom-opt").each(function(){

      var _this = $(this);

      var color = $(this).find(".color-opt").text();

      var size = [];

      $(this).find(".size-opt").each(function(){
       var s = $(this).attr("data-size");
       size.push(s);
      });

      var piece_qty = 0;

      var total_price = 0;
      
      var max = 0;
      
      var bundle_max = 0;
      
      var inventory = '';
      
      var policy = '';

      for(var i=0;i<size.length;i++)
      {
        var opt = color;
        var bundle_qty = _this.find("[data-size='"+size[i]+"']").attr("data-qty");

        var bundle_price = $("select[name='id']").find("option[data-title='"+opt+"']").attr("data-price");

        var bundle_id = $("select[name='id']").find("option[data-title='"+opt+"']").val();
        
        bundle_max = $("select[name='id']").find("option[data-title='"+opt+"']").attr("data-max");
        
        inventory = $("select[name='id']").find("option[data-title='"+opt+"']").attr("data-show-inventory");
        
        policy = $("select[name='id']").find("option[data-title='"+opt+"']").attr("data-policy");
        


        if(bundle_qty == '')
        {
          bundle_qty = 1 ;
        }
        
 //       max += parseInt(bundle_max) / parseInt(bundle_qty);

        total_price = parseFloat(bundle_price.replace( /[^\d.]/g, '' ));

        piece_qty += parseInt(bundle_qty); 
        
        _this.find("[data-size='"+size[i]+"']").attr("data-price",bundle_price.replace( /[^\d.]/g, '' ));

        _this.find("[data-size='"+size[i]+"']").attr("data-id",bundle_id);
        
        _this.find("[data-size='"+size[i]+"']").attr("data-policy",policy);

    //    _this.find("[data-size='"+size[i]+"']").text(bundle_qty);
      }
      
      console.log(bundle_max);

   //   _this.find(".total-qty").text(piece_qty);
      
      _this.attr("data-piece",piece_qty);

   //   _this.find(".total-amount").text("$"+total_price.toFixed(2));
      
      _this.attr("data-total",total_price.toFixed(2));
      
      if(policy != 'continue')
      { 
        if(bundle_max <= 0)
        {
           _this.addClass("disabled");
        }

        _this.attr("data-max",parseInt(bundle_max));

      }
      else
      {
        _this.attr("data-max",parseInt('1000000'));
      }
        if(inventory !='')
        {
          _this.attr("data-inventory",inventory);
        }
        else
        {
          _this.attr("data-inventory","false");
        }

    });


    setTimeout(function(){
     // $(".pack").html("<input type='number' class='pack-qty' value='0'/>");
    //  $(".apply-all").append("<input type='number' class='apply-all-qty' value='0'/>");
      $(".custom-opt").each(function(){
        var policy = $(this).attr("data-policy");
        var max = $(this).attr("data-max");
        var qty = $(this).attr("data-piece");
        var inventory = $(this).attr("data-inventory");
        
        max = parseInt(max) / parseInt(qty);
        
        max = parseInt(max);
        
        if(max <= 0)
        {
            max = 0;
            $(this).addClass("disabled");
        }
        
        if(policy != 'continue')
      	{
        
          if(inventory == "true")
          {
             $(this).find(".pack-qty").after("<span class='invtry'>"+max+"</span>");

             if(max <= 0)
             {
               $(this).find(".invtry").addClass("disabled");
             }
          }

          $(this).find(".pack-qty").attr("max",parseInt(max));
        }
      });
    },500);

    $(document).on("change keyup",".pack-qty",function(e){
      var val = $(this).val();
      
      $(this).siblings(".size-calibration").text(val);
      
      if(e.keyCode != 8)
      {
        var max_val = $(this).attr("max");
        
        if(max_val != 'NaN')
        {
          if(parseInt(max_val) < parseInt(val))
          {
            $(this).val(max_val);
            val = max_val;
            $(this).siblings(".size-calibration").text(max_val);
          }
        }

        if(val<=0)
        {
          $(this).val("0");
          $(this).siblings(".size-calibration").text("0");

          var fnl_prc = 0;

          var fnl_ttl = 0;
        }
        else
        {
          var prc = $(this).parents(".custom-opt").attr("data-piece");
          var ttl = $(this).parents(".custom-opt").attr("data-total");

          var fnl_prc = parseFloat(prc) * parseInt(val);

          var fnl_ttl = parseFloat(ttl);
        }
        
        var totl_amt = parseFloat(fnl_ttl)*parseFloat(fnl_prc);

        $(this).parents(".custom-opt").find(".total-qty").text(fnl_prc);

        $(this).parents(".custom-opt").find(".total-amount").text("$"+totl_amt.toFixed(2));

  //      $(this).parents(".custom-opt").siblings().find(".pack-qty").val("0");

  //       total bundle price/piece/qty
        var b_price = 0;

        var b_piece = 0;

        var b_qty = 0;

        $(".total-qty").each(function(){
         var v = $(this).text();
         b_piece += parseInt(v); 
        });

        $(".pack-qty").each(function(){
         var v = $(this).val(); 
         b_qty += parseInt(v); 
        });

        $(".total-amount").each(function(){
         var v = $(this).text();
         b_price += parseFloat(v.replace( /[^\d.]/g, '' )); 
        });

        $(".total-heading").find(".count").text(b_piece);

        $(".total_amount").text("$"+b_price.toFixed(2));

        $(".total_qty").text(b_qty); 
      }   

    });
    
    
//     $(document).on("keypress",".pack-qty",function(event){   
//        var keyPressed = event.keyCode || event.which;
//        if (keyPressed === 13) {
//           $(this).parents(".custom-opt").next().find(".pack-qty").trigger("focus");
//        }
//     });
    
    
    $(document).on("change keyup",".apply-all-qty",function(e){
      var val = $(this).val();
      
      $(this).siblings(".all-size-calibration").text(val);
      
      if(e.keyCode != 8)
      {
      //  var val = $(this).val();
        
        if(val<=0)
        {
          $(this).val("0");
          $(this).siblings(".all-size-calibration").text("0");
          val = 0;
        }

        $(".pack-qty").each(function(){
        	if(!$(this).parents(".custom-opt").hasClass("disabled"))
            {
              $(this).val(val).trigger("change");
            }
        });
      }
      
    });

    $(document).on("click", ".color-opt", function(event) {
      var img_id = $(this).attr("data-img-id");
      if(img_id != '')
      {
        $(".product-thumbnail[data-image-id='"+img_id+"']").trigger("click");
      }
    });


    $(document).on("click",".custom_add",function(e){
      e.preventDefault();
      
      var _this = $(this);
      
      _this.addClass("disabled");
      
      _this.find(".loader").show();

      var ids = [];

      var qtys = [];

      var pck_qty = [];
      
      var ratio = [];
      
      var preorder = $(".custom-variants").attr("data-ptype");

      $(".pack-qty").each(function(){
       var val = $(this).val();

       if(val != 0)
       {
         var size_opt = $(this).parents(".custom-opt").find(".size-opt");

          var id = size_opt.attr("data-id");
         
         
          var qt = $(this).parents(".custom-opt").find(".total-qty").text();

          ids.push(id);

          qtys.push(qt);
         
         var pck = 0;
         var rtio = '';
         
         size_opt.each(function(index){
           var v = $(this).attr("data-qty");
           var s = $(this).attr("data-size");
           pck += parseInt(v); 
           console.log(index);
           if(index == 0)
           {
             if(v != 0)
             {
             	rtio += s+"["+v+"]";
             }
           }
           else
           {
             if(v != 0)
             {
             	rtio += "-"+s+"["+v+"]";
             }
           }
         });
         
         pck_qty.push(pck);
         
         ratio.push(rtio);
           

       }
      });

      
      var total_pck_qty = $(".total_qty").text();

      var style_no = $(".style-no").text();

      
      setTimeout(function(){
        if(ids != '')
        {
         for(var q=0;q<ids.length;q++)
          {
            if(preorder != '')
            {
              var data = 'quantity=' + qtys[q] + '&id=' + ids[q] + "&properties[Prepack]=["+pck_qty[q]+"Pcs/Pack]&properties[Size Ratio]="+ratio[q] + "&properties[Note]="+preorder + "&properties[Style No]="+style_no;
            }
            else
            {
              var data = 'quantity=' + qtys[q] + '&id=' + ids[q] + "&properties[Prepack]=["+pck_qty[q]+"Pcs/Pack]&properties[Size Ratio]="+ratio[q] + "&properties[Style No]="+style_no;
            }
            
            
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: data ,
                async:false,
                success: function(response){

                },
                error: function(error){
                }
             });
           }
          
		  if($("[data-cart='link']").hasClass("site-header__cart-toggle"))
          {
          	$(".js-drawer-open-right").trigger("click");
          }
          else
          {
           // window.location.href = "/cart";
            $(".cart-notification").show();
            
            document.body.scrollTop = 0;
            
  			document.documentElement.scrollTop = 0;  
            
            $.ajax({
                type: 'GET', 
                url: '/cart',
                dataType: 'HTML',
                success: function(data){
                 var count =  $(data).find("[data-cart='link'] .CartCount").text();
                 var price =  $(data).find(".CartCost").html(); 
                  
                 $("[data-cart='link'] .CartCount").text(count);
                  
                 $("[data-cart='link1'] .CartCount").text(count); 
                  
                 $(".CartCost").html(price); 
                  

                },
                error: function(error){
                }
             });
          }

           _this.removeClass("disabled");
          
          _this.find(".loader").hide();

        }
        else
        {
          _this.removeClass("disabled");
          
          _this.find(".loader").hide();
          
          alert("Please select quantity!");
        }
        
      },100);  


    });
  }
  
  
  if($('[data-type="single-pc"]').length != 0)
  {
    setTimeout(function(){
    	$(".size-opt").html("<span class='size-qty-vl'>0</span><input type='number' class='size-qty' value='0'/>");
      
        $(".size-qty").each(function(){
          var size = $(this).parent(".size-opt").attr("data-size");
          var color = $(this).parent(".size-opt").siblings(".color-opt").text();

          var opt1 = color+' / '+size;

          var max = $("select[name='id']").find("option[data-title='"+opt1+"']").attr("data-max");
          
          var inventory = $("select[name='id']").find("option[data-title='"+opt1+"']").attr("data-show-inventory");
          
          var policy = $("select[name='id']").find("option[data-title='"+opt1+"']").attr("data-policy");
          
          if(policy != 'continue')
          { 

            if(max <= 0)
            {
              max = 0;
            }
          }
          
          if(inventory == 'true' )
          {
            $(this).after("<span class='invtry'>"+max+"</span>");
            if(policy != 'continue')
            {
              if(max <= 0)
              {
                $(this).siblings(".invtry").addClass("disabled");
              }
            }
          }
          
          if(policy != 'continue')
          {

            if(max != 0)
            {
              $(this).attr("max",max);
            }
            else
            {
              $(this).attr("disabled","");
            }
          }
          else
          {
            $(this).attr("max",'1000000');
          }
			
          	
        });
    },500);
    
    
    $(document).on("change keyup",".size-qty",function(e){
      var val = $(this).val();
      
      $(this).siblings(".size-qty-vl").text(val);
      
      if(e.keyCode != 8)
      {
    
        //var val = $(this).val();

        var max_val = $(this).attr("max");

        var opt = $(this).parents(".custom-opt");

        if(val<=0)
        {
          $(this).val("0");
        }

        if(parseInt(max_val) < parseInt(val))
        {
          $(this).val(max_val);
          $(this).siblings(".size-qty-vl").text(max_val);
        }

        var init_price = opt.find(".price").text();

        var total_size_qty = 0;

        var total_size_price = 0;

        opt.find(".size-qty").each(function(){
          var v = $(this).val();
          total_size_qty += parseInt(v);
        });

        total_size_price += parseFloat(init_price.replace( /[^\d.]/g, '' )) * parseInt(total_size_qty);

        console.log(total_size_price);

        opt.find(".total-qty").text(total_size_qty);

        opt.find(".total-amount").text("$"+total_size_price.toFixed(2));


     //   $(this).parent(".size-opt").siblings(".size-opt").find(".size-qty").val("0");

    //    opt.siblings().find(".size-qty").val("0");

  //      opt.siblings().find(".total-qty").text("0");

  //      opt.siblings().find(".total-amount").text("$0.00");
      }
    
    });
    
    
    $(document).on("click",".custom_add",function(e){
      
      e.preventDefault();
      
      var _this = $(this);
      
      _this.addClass("disabled");
      
      _this.find(".loader").show();
      
      
      var id = [];
      
      var qty =[];
      
      var preorder = $(".custom-variants").attr("data-ptype");
      
      $(".size-qty").each(function(){
      	var val = $(this).val();
        
        if(val != 0)
        {
          var size = $(this).parent(".size-opt").attr("data-size");
          var color = $(this).parent(".size-opt").siblings(".color-opt").text();
          
          var opt1 = color+' / '+size;
          
          var s_id = $("select[name='id']").find("option[data-title='"+opt1+"']").val();
          
          id.push(s_id);
          
          qty.push(val);
          
        }
      });

      var style_no = $(".style-no").text();
      
      
      setTimeout(function(){
        if(id != '')
        {
          for(var q=0;q<id.length;q++)
          {
            if(preorder != '')
            {
              var data = 'quantity=' + qty[q] + '&id=' + id[q] + "&properties[Note]="+preorder + "&properties[Style No]="+style_no;
            }
            else
            {
            	var data = 'quantity=' + qty[q] + '&id=' + id[q] + "&properties[Style No]="+style_no;
            }
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: data,
                async:false,
                success: function(response){

                },
                error: function(error){
                }
             });
           }
          
          if($("a[data-cart='link']").hasClass("site-header__cart-toggle"))
          {
          	$(".js-drawer-open-right").trigger("click");
          }
          else
          {
           // window.location.href = "/cart";
            
           $(".cart-notification").show();
            
            document.body.scrollTop = 0;
            
  			document.documentElement.scrollTop = 0;  
            
            $.ajax({
                type: 'GET', 
                url: '/cart',
                dataType: 'HTML',
                success: function(data){
                 var count =  $(data).find("[data-cart='link'] .CartCount").text();
                 var price =  $(data).find(".CartCost").html();
                  
                 $("[data-cart='link'] .CartCount").text(count);
                  
                 $("[data-cart='link1'] .CartCount").text(count);
                  
                 $(".CartCost").html(price); 
                  
                },
                error: function(error){
                }
             }); 
            
          }

          _this.removeClass("disabled");
          
          _this.find(".loader").hide();

        }
        else
        {
          _this.removeClass("disabled");
          
          _this.find(".loader").hide();
          
          alert("Please select quantity!");
        }
        
      },100);
      
    
    });
    
  }

  $(document).on("click", ".color-opt", function(event) {
    var img_id = $(this).attr("data-img-id");
    if(img_id != '')
    {
      $(".product-thumbnail[data-image-id='"+img_id+"']").trigger("click");
    }
  });
  
  $(document).on("keydown", "form", function(event) { 
      return event.key != "Enter";
  });

  
});